module.exports = __webpack_public_path__ + "img/bg2.f881c49f.png";